export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.BasicInformation'

export const POSITIVE = 'Positive'
export const NEGATIVE = 'Negative'

export const TREND = {
    STAGNATION: 'stagnation',
    DECREASE: 'decrease',
    INCREASE: 'increase',
    STEEP_DECREASE: 'steepDecrease',
    STEEP_INCREASE: 'steepIncrease',
}
